<template>
  <section class="container-fluid my-4">
    <h4 class="my-4">Relatório de <strong>Agendas Semanais</strong></h4>

    <form @submit.prevent="generateReport">
      <div class="row">
        <div class="form-group col-md-6">

          <div class="mb-3">
            <label class="form-label">Usuário <span class="text-danger">*</span></label>
            <select v-model="user_id" class="form-control form-control-sm" required>
              <option value="">-- Selecione um usuário --</option>
              <option v-for="user in users" :key="user.id" :value="user.id">
                {{ user.name }}
              </option>
            </select>
          </div>

          <div class="row">
            <div class="col-md-6 mb-3">
              <label class="form-label">Data Inicial</label>
              <input type="date" v-model="start_date" class="form-control form-control-sm" />
              <small class="text-muted">Padrão: últimos 30 dias</small>
            </div>
            <div class="col-md-6 mb-3">
              <label class="form-label">Data Final</label>
              <input type="date" v-model="end_date" class="form-control form-control-sm" />
              <small class="text-muted">Padrão: hoje</small>
            </div>
          </div>

          <div v-if="!loading" class="form-group text-center my-2">
            <button type="submit" class="btn btn-success btn-sm mx-2 text-uppercase">
              Gerar Relatório
            </button>
            <button type="reset" class="btn btn-secondary btn-sm text-uppercase" @click="clearForm">
              Limpar
            </button>
          </div>

          <LoadingPage v-else />

        </div>
      </div>
    </form>

    <button class="btn btn-sm btn-secondary mt-3" @click="$router.go(-1)">
      VOLTAR
    </button>
  </section>
</template>

<script>
import api from "@/services";
import LoadingPage from "@/components/LoadingPage.vue";
import { handleBlobError } from "@/helpers";

export default {
  name: "WeeklyFlowsReport",
  components: { LoadingPage },
  data() {
    return {
      user_id: "",
      start_date: "",
      end_date: "",
      loading: false,
      users: [],
    };
  },
  methods: {
    async generateReport() {
      if (!this.user_id) {
        Toast.fire("Selecione um usuário.", "", "warning");
        return;
      }

      this.loading = true;

      const params = { user_id: this.user_id };
      if (this.start_date) params.start_date = this.start_date;
      if (this.end_date) params.end_date = this.end_date;

      try {
        const response = await api.get("/exports/weekly-flows-report", {
          params,
          responseType: "blob",
        });

        const start = this.start_date || "periodo";
        const url  = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", `agenda-semanal_${start}.xlsx`);
        document.body.appendChild(link);
        link.click();
        link.remove();
        window.URL.revokeObjectURL(url);

        Toast.fire("Relatório gerado com sucesso!", "", "success");
      } catch (error) {
        handleBlobError(error, (message) => {
          Toast.fire("Erro", message, "error");
        });
      } finally {
        this.loading = false;
      }
    },
    clearForm() {
      this.user_id    = "";
      this.start_date = "";
      this.end_date   = "";
    },
    async loadUsers() {
      const { data } = await api.get("/users?page=0&perPage=99999");
      this.users = data.data;
    },
  },
  async mounted() {
    await this.loadUsers();
  },
};
</script>
